//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isNullOrEmpty} from '@nuskin/ns-common-lib';
export default {
  name: 'PurchaseTypeSelector',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    /**
     * The purchase type
     * @values BUY_ONCE, SUBSCRIPTION
     */
    value: {
      type: String,
      default: 'BUY_ONCE'
    },
    buyOncePrice: {
      type: Number,
      default: 0
    },
    subscriptionPrice: {
      type: Number,
      default: 0
    },
    noSubscription: {
      type: Boolean,
      default: false
    },
    hideSubscription: {
      type: Boolean,
      default: false
    },
    subscriptionOnly: {
      type: Boolean,
      default: false
    },
    currencyCode: {
      type: String,
      default: ''
    },
    bundlePrice: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    currencyLocale() {
      return this.$store.getters['nuskin/currencyLocale'] || '';
    },
    purchaseTypes() {
      if (this.hideSubscription) {
        return ['BUY_ONCE'];
      }
      return ['BUY_ONCE', 'SUBSCRIPTION'];
    },
    selectedLabel() {
      const label = this.labels[
        this.subscriptionOnly ? 'SUBSCRIPTION' : this.value
      ];
      return (label && label.toUpperCase()) || '';
    },
    labels() {
      return {
        BUY_ONCE: this.$t('buyOnce'),
        SUBSCRIPTION: this.$t('subscribe')
      };
    },
    buyOnceAmount() {
      if (!isNullOrEmpty(this.bundlePrice)) {
        const buyOnce = this.bundleBuyOnce();
        return this.formatCurrency(buyOnce);
      }
      return this.formatCurrency(this.buyOncePrice);
    },
    subscriptionAmount() {
      const bundleSubscribePrice = !isNullOrEmpty(this.bundlePrice)
        ? this.bundleBuySubscription()
        : 0;
      if (!isNullOrEmpty(this.bundlePrice) && bundleSubscribePrice > 0) {
        return this.formatCurrency(bundleSubscribePrice);
      }
      return this.subscriptionPrice > 0
        ? this.formatCurrency(this.subscriptionPrice)
        : '';
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.value);
    },
    isSelected(option) {
      if (this.subscriptionOnly) {
        return option === 'SUBSCRIPTION';
      } else {
        return option === this.value;
      }
    },
    isAvailable(value) {
      switch (value) {
        case 'BUY_ONCE':
          return !this.subscriptionOnly;
        case 'SUBSCRIPTION':
          this.$emit(
            'hideSubscriptionPrice',
            !this.noSubscription && this.subscriptionPrice > 0
          );
          return !this.noSubscription && this.subscriptionPrice > 0;
        default:
          return false;
      }
    },
    formatCurrency(value) {
      if (!this.currencyCode || !this.currencyLocale) {
        console.warn(
          `[Catalog] Currency unknown. Code ['USD']: '${this.currencyCode}', Locale ['en-US']: '${this.currencyLocale}'.`
        );
      }
      return Intl.NumberFormat(this.currencyLocale || 'en-US', {
        style: 'currency',
        currency: this.currencyCode || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(typeof value === 'object' ? 0 : value || 0);
    },
    bundleBuyOnce() {
      if (!isNullOrEmpty(this.bundlePrice)) {
        const priceKey = this.isWholesale ? 'wholesale' : 'retail';
        return (this.bundlePrice || {})[priceKey];
      }
    },
    bundleBuySubscription() {
      if (!isNullOrEmpty(this.bundlePrice)) {
        const priceKey = this.isWholesale
          ? 'wholesaleSubscription'
          : 'retailSubscription';
        return (this.bundlePrice || {})[priceKey];
      }
    }
  }
};
